import React, { useEffect, useState } from 'react';
import Team from '../Team/Team';
import './Home.css'

const Home = () => {
    const [teams, setTeams] = useState([]);

    useEffect(() => {
        fetch("https://www.thesportsdb.com/api/v1/json/1/search_all_teams.php?l=English%20Premier%20League")
            .then(res => res.json())
            .then(data => setTeams(data.teams))
    }, [])
    return (
        <>
            <div style={{ margin: '0 auto', padding: '5px 5px' }} className='d-flex row col-sm club-details shadow p-3 mb-5 bg-body rounded'>
                {
                    teams.map(team => <Team key={team.idTeam} team={team}></Team>)
                }
            </div>
        </>
    );
};

export default Home;